export default "__VITE_ASSET__U1m$qCOK__"